import React from 'react';
import { FieldRenderProps } from 'react-final-form';

interface ITextInputProps extends FieldRenderProps<string, HTMLInputElement> { }

const TextInput: React.FC<ITextInputProps> = ({ input, meta, placeholder }) => {
    return (
        <div>
            <input {...input} placeholder={placeholder} />
            {meta.touched && meta.error && <span className="dcr-error">{meta.error}</span>}
        </div>
    );
};

export default TextInput;
